import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { t } from 'ttag'
import introStyles from '../IntroPage/IntroPage.module.scss'
import { BellCurve } from 'components/shared/BellCurve/BellCurve'
import { Stats } from 'components/shared/Stats/Stats'

import styles from './GMA.module.scss'
import reportStyles from '../../Report.module.scss'

import { useGMAState } from 'components/modals/TestsReportModal/tabs/ProcessingSpeed/hooks'

export const GMAPage = ({ language, response, isCandidate, candidates }) => {
  const {
    state: { translations, scores, allScores },
  } = useGMAState({
    factor: 'GMA',
    language,
    response,
    isCandidate,
    candidates,
  })

  return (
    <Box
      className={reportStyles.containerWhite}
      direction="column"
      id="report"
      data-testid="report"
    >
      <div className={cx(introStyles.header, introStyles.headerPadding)}>
        <div className={introStyles.name}>{t`General mental ability`}</div>
        <div className={introStyles.position}>
          {t`Ability to learn, understand instructions, and solve problems`}
        </div>
      </div>

      <Stats scores={scores} candidates={candidates} single />

      <div className={styles.bellCurve}>
        <BellCurve
          allScores={allScores}
          hideScore={isCandidate}
          candidates={candidates}
          high
          single
        />
      </div>

      <div className={styles.description}>
        {translations[0].translation.abstract.map((par, index) => (
          <>
            <div key={index} className={styles.paragraph}>
              {par}
            </div>
            {[3, 0].includes(index) ? <br /> : null}
          </>
        ))}
        <br />
        <div className={cx(styles.paragraph, styles.bold)}>
          {translations[0].description}
        </div>
      </div>
    </Box>
  )
}
